import {floatFormatter} from '../Common/util';

// 이행진단통계
export const summaryColumnData = [
    {
        title: '분류',
        align: 'center',
        colSpan: 2,
        rowSpan: 2,
        children: [
            {
                title: ' ',
                dataIndex: 'code',
                key: 'code',
                width: '70px',
                align: 'center',
                ellipsis : true,
                colSpan : 0,
            },
            {
                title: ' ',
                dataIndex: 'name',
                key: 'name',
                width: '150px',
                align: 'center',
                ellipsis : true,
                colSpan : 0,
            },
        ]
    },
    {
        title: '진단결과',
        align: 'center',
        children: [
            {
                title: '전체항목',
                dataIndex: 'total',
                key: 'total',
                width: '70px',
                align: 'center',
            },
            {
                title: '진단항목',
                dataIndex: 'check',
                key: 'check',
                width: '70px',
                align: 'center',
            },
            {
                title: '양호',
                dataIndex: 'Y',
                key: 'Y',
                width: '70px',
                align: 'center',
            },
            {
                title: '취약',
                dataIndex: 'N',
                key: 'N',
                width: '70px',
                align: 'center',
            },
            {
                title: '부분이행',
                dataIndex: 'P',
                key: 'P',
                width: '70px',
                align: 'center',
            },
            {
                title: '해당없음',
                dataIndex: 'NA',
                key: 'NA',
                width: '70px',
                align: 'center',
            },
        ]
    },
    {
        title: '중요도점수',
        align: 'center',
        children: [
            {
                title: '전체점수',
                dataIndex: 'total_score',
                key: 'total_score',
                width: '70px',
                align: 'center',
            },
            {
                title: '평가점수',
                dataIndex: 'eval_score',
                key: 'eval_score',
                width: '70px',
                align: 'center',
            },
            {
                title: '보안수준',
                key: 'level',
                width: '70px',
                align: 'center',
                render: (_ , rowData ) => {
                    return (
                        <>
                            {rowData.level}%
                        </>
                    );
                },
            }
        ]
    },
];


// 이행진단통계-자산별
export const assetColumnData = [
    {
        title: '분류',
        align: 'center',
        colSpan: 2,
        rowSpan: 2,
        children: [
            {
                title: ' ',
                dataIndex: 'code',
                key: 'code',
                width: '70px',
                align: 'center',
                ellipsis : true,
                render: (_ , rowData ) => {
                    let tag_color ='';
                    if(rowData.copy_yn == 'N') {
                        tag_color = 'blue';
                    } 
                    return <span style={{color:tag_color}}>{rowData.code}</span>
                },
                colSpan: 0,
            },
            {
                title: ' ',
                dataIndex: 'name',
                key: 'name',
                width: '150px',
                align: 'center',
                ellipsis : true,
                render: (_ , rowData ) => {
                    let tag_color ='';
                    if(rowData.copy_yn == 'N') {
                        tag_color = 'blue';
                    } 
                    return <span style={{color:tag_color}}>{rowData.name}</span>
                },
                colSpan: 0,
            },
        ]
    },
    {
        title: '진단결과',
        align: 'center',
        children: [
            {
                title: '전체항목',
                dataIndex: 'total',
                key: 'total',
                width: '70px',
                align: 'center',
                render: (_ , rowData ) => {
                    let tag_color ='';
                    if(rowData.copy_yn == 'N') {
                        tag_color = 'blue';
                    } 
                    return <span style={{color:tag_color}}>{rowData.total}</span>
                },
            },
            {
                title: '진단항목',
                dataIndex: 'check',
                key: 'check',
                width: '70px',
                align: 'center',
                render: (_ , rowData ) => {
                    let tag_color ='';
                    if(rowData.copy_yn == 'N') {
                        tag_color = 'blue';
                    } 
                    return <span style={{color:tag_color}}>{rowData.check}</span>
                },
            },
            {
                title: '양호',
                dataIndex: 'Y',
                key: 'Y',
                width: '70px',
                align: 'center',
                render: (_ , rowData ) => {
                    let tag_color ='';
                    if(rowData.copy_yn == 'N') {
                        tag_color = 'blue';
                    } 
                    return <span style={{color:tag_color}}>{rowData.Y}</span>
                },
            },
            {
                title: '취약',
                dataIndex: 'N',
                key: 'N',
                width: '70px',
                align: 'center',
                render: (_ , rowData ) => {
                    let tag_color ='';
                    if(rowData.copy_yn == 'N') {
                        tag_color = 'blue';
                    } 
                    return <span style={{color:tag_color}}>{rowData.N}</span>
                },
            },
            {
                title: '부분이행',
                dataIndex: 'P',
                key: 'P',
                width: '70px',
                align: 'center',
                render: (_ , rowData ) => {
                    let tag_color ='';
                    if(rowData.copy_yn == 'N') {
                        tag_color = 'blue';
                    } 
                    return <span style={{color:tag_color}}>{rowData.P}</span>
                },
            },
            {
                title: '해당없음',
                dataIndex: 'NA',
                key: 'NA',
                width: '70px',
                align: 'center',
                render: (_ , rowData ) => {
                    let tag_color ='';
                    if(rowData.copy_yn == 'N') {
                        tag_color = 'blue';
                    } 
                    return <span style={{color:tag_color}}>{rowData.NA}</span>
                },
            },
        ]
    },
    {
        title: '중요도점수',
        align: 'center',
        children: [
            {
                title: '전체점수',
                dataIndex: 'total_score',
                key: 'total_score',
                width: '70px',
                align: 'center',
                render: (_ , rowData ) => {
                    let tag_color ='';
                    if(rowData.copy_yn == 'N') {
                        tag_color = 'blue';
                    } 
                    return <span style={{color:tag_color}}>{rowData.total_score}</span>
                },
            },
            {
                title: '평가점수',
                dataIndex: 'eval_score',
                key: 'eval_score',
                width: '70px',
                align: 'center',
                render: (_ , rowData ) => {
                    let tag_color ='';
                    if(rowData.copy_yn == 'N') {
                        tag_color = 'blue';
                    } 
                    return <span style={{color:tag_color}}>{rowData.eval_score}</span>
                },
            },
            {
                title: '보안수준',
                key: 'level',
                width: '70px',
                align: 'center',
                render: (_ , rowData ) => {
                    let tag_color ='';
                    if(rowData.copy_yn == 'N') {
                        tag_color = 'blue';
                    } 
                    return (
                        <>
                            <span style={{color:tag_color}}>{rowData.level}%</span>
                        </>
                    );
                },
            }
        ]
    },
];


// 이행진단 전.후 보완수준
export const compareColumnData = [
    {
        title: '구분',
        dataIndex: 'code',
        key: 'code',
        width: '70px',
        align: 'center',
        ellipsis : true,
        className: 'head_col',
        render: (_ , rowData ) => {
            let tag_color ='';
            if(rowData.copy_yn == 'N') {
                tag_color = 'blue';
            } 
            return <span style={{color:tag_color}}>{rowData.code}</span>
        },
    },
    {
        title: '자산명',
        dataIndex: 'name',
        key: 'name',
        width: '150px',
        align: 'center',
        ellipsis : true,
        className: 'head_col',
        render: (_ , rowData ) => {
            let tag_color ='';
            if(rowData.copy_yn == 'N') {
                tag_color = 'blue';
            } 
            return <span style={{color:tag_color}}>{rowData.name}</span>
        }, 
    },
    {
        title: '조치전',
        align: 'center',
        children: [
            {
                title: '전체점수',
                dataIndex: 'total_score',
                key: 'total_score',
                width: '70px',
                align: 'center',
                sorter: {
                    compare: (a, b) => a.total_score - b.total_score,
                },
            },
            {
                title: '평가점수',
                dataIndex: 'eval_score',
                key: 'eval_score',
                width: '70px',
                align: 'center',
                sorter: {
                    compare: (a, b) => a.eval_score - b.eval_score,
                },
            },
            {
                title: '보안수준',
                key: 'level',
                width: '70px',
                align: 'center',
                render: (_ , rowData ) => {
                    return (
                        <>
                            {rowData.level}%
                        </>
                    );
                },
                sorter: {
                    compare: (a, b) => a.level - b.level,
                },
            }
        ]
    },
    {
        title: '이행진단',
        align: 'center',
        className: 'edit_col',
        children: [
            {
                title: '전체점수',
                dataIndex: 'total_score_U',
                key: 'total_score_U',
                width: '70px',
                align: 'center',
                className: 'edit_col',
                render: (_ , rowData ) => {
                    if (rowData.improve_rate > 0 ) {
                        return (<span style={{color:'blue'}}> {rowData.total_score_U} </span>);
                    } else if (rowData.improve_rate < 0 ) {
                        return (<span style={{color:'red'}}> {rowData.total_score_U} </span>);
                    } else {
                        return (<span style={{color:'black'}}> {rowData.total_score_U} </span>);
                    }
                },  
                sorter: {
                    compare: (a, b) => a.total_score_U - b.total_score_U,
                },
            },
            {
                title: '평가점수',
                dataIndex: 'eval_score_U',
                key: 'eval_score_U',
                width: '70px',
                align: 'center',
                className: 'edit_col',
                render: (_ , rowData ) => {
                    if (rowData.improve_rate > 0 ) {
                        return (<span style={{color:'blue'}}> {rowData.eval_score_U} </span>);
                    } else if (rowData.improve_rate < 0 ) {
                        return (<span style={{color:'red'}}> {rowData.eval_score_U} </span>);
                    } else {
                        return (<span style={{color:'black'}}> {rowData.eval_score_U} </span>);
                    }
                },
                sorter: {
                    compare: (a, b) => a.eval_score_U - b.eval_score_U,
                },
            },
            {
                title: '보안수준',
                key: 'level_U',
                width: '70px',
                align: 'center',
                render: (_ , rowData ) => {
                    if (rowData.improve_rate > 0 ) {
                        return (<span style={{color:'blue'}}> {rowData.level_U}% </span>);
                    } else if (rowData.improve_rate < 0 ) {
                        return (<span style={{color:'red'}}> {rowData.level_U}% </span>);
                    } else {
                        return (<span style={{color:'black'}}> {rowData.level_U}% </span>);
                    }
                },
                className: 'edit_col',
                sorter: {
                    compare: (a, b) => a.level_U - b.level_U,
                },
            }
        ]
    },
    {
        title: '향상도',
        dataIndex: 'improve_rate',
        key: 'improve_rate',
        width: '70px',
        align: 'center',
        render: (_ , rowData ) => {
            if (rowData.improve_rate > 0 ) {
                return (<span style={{color:'blue'}}> {floatFormatter(rowData.improve_rate,1)}% </span>);
            } else if (rowData.improve_rate < 0 ) {
                return (<span style={{color:'red'}}> {floatFormatter(rowData.improve_rate,1)}% </span>);
            } else {
                return (<span style={{color:'black'}}> {floatFormatter(rowData.improve_rate,1)}% </span>);
            }
        },
        sorter: {
            compare: (a, b) => a.improve_rate - b.improve_rate,
        },
    },
];
